<script lang="ts">
	import { Section } from "#lib/web-ui/primitives/index.js";

	interface Props {
		entityName: string;
	}

	let { entityName }: Props = $props();
</script>

<Section class="border-background/10 border-t bg-transparent py-4 md:py-4">
	<p class="text-background/60 text-center text-xs">
		Investing involves risk, including loss of principal. Past performance does not guarantee or
		indicate future results. Any historical returns, expected returns, or probability
		projections may not reflect actual future performance. While the data we use from third
		parties is believed to be reliable, we cannot ensure the accuracy or completeness of data
		provided by investors or other third parties. Neither {entityName} nor any of its affiliates
		provide tax advice and do not represent in any manner that the outcomes described herein will
		result in any particular tax consequence. Offers to sell, or solicitations of offers to buy,
		any security can only be made through official offering documents that contain important information
		about investment objectives, risks, fees and expenses.
	</p>
</Section>
